import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MergeObjectPipe } from './merge-object.pipe';
import { GetPropertyPipe } from './get-property.pipe';
import { SplitPipe } from './split.pipe';
import { JoinPipe } from './join.pipe';



@NgModule({
  declarations: [
    MergeObjectPipe,
    GetPropertyPipe,
    SplitPipe,
    JoinPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    MergeObjectPipe,
    GetPropertyPipe,
    SplitPipe,
    JoinPipe
  ]
})
export class UtilityModule { }
